import { messages } from '@/i18n/messages';
import { useT } from '@/i18n';
import { errorKey } from '@/lib/errors';

export function useErrorText() {
  const t = useT();
  return (err: unknown) => {
    const k = errorKey(err);
    return messages.ru[k] ? t(k) : t('err.generic');
  };
}
